<div class="preview-stack" [class.preview-stack--empty]="variant === 'empty'" aria-hidden="true">
  <div class="preview-stack-card preview-stack-card--layer3">
    <div class="preview-stack-card-header">
      <span class="preview-stack-card-name">{{ 'thematicStrategyPreviewStack.layerName' | translate }}</span>
      <span class="preview-stack-card-yield">+12,94&nbsp;%</span>
    </div>
    <div class="preview-stack-card-image">
      <img src="assets/img/values-strategy-startups.png" alt="Sample photo for a thematic strategy" />
    </div>
    <p class="preview-stack-card-description">{{ 'thematicStrategyPreviewStack.frontDescription' | translate }}</p>
  </div>
  <div class="preview-stack-card preview-stack-card--layer2">
    <div class="preview-stack-card-header">
      <span class="preview-stack-card-name">{{ 'thematicStrategyPreviewStack.layerName' | translate }}</span>
      <span class="preview-stack-card-yield">+17,84&nbsp;%</span>
    </div>
    <div class="preview-stack-card-image">
      <img src="assets/img/values-strategy-sustainability.png" alt="Sample photo for a thematic strategy" />
    </div>
    <p class="preview-stack-card-description">{{ 'thematicStrategyPreviewStack.frontDescription' | translate }}</p>
  </div>
  <div class="preview-stack-card preview-stack-card--front">
    <div class="preview-stack-card-header">
      <img class="preview-stack-card-logo" src="assets/img/values-strategy-nadace.png" alt="Nobel Foundation logo" />
      <span class="preview-stack-card-name">{{ 'thematicStrategyPreviewStack.frontName' | translate }}</span>
      <span class="preview-stack-card-yield">+10,87&nbsp;%</span>
    </div>
    <div class="preview-stack-card-image">
      <img src="assets/img/values-strategy-nadace-chart.png" alt="Close-up of a Nobel medal" />
    </div>
    <p class="preview-stack-card-description">{{ 'thematicStrategyPreviewStack.frontDescription' | translate }}</p>
    @if (variant === 'grid') {
      <button type="button" class="preview-stack-card-cta">
        {{ 'thematicStrategyPreviewStack.frontCta' | translate }}
      </button>
    }
  </div>
</div>
